
import React from "react";
import { DialogProps } from "./DialogProps";
import {
  Button, Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
export interface ConfirmationDialogProps extends DialogProps<void> {
  title: string;
  prompt: string;
}

export default function ConfirmationDialog(props: ConfirmationDialogProps) {
  return (
    <>
      <Dialog open={true} fullScreen={false}>
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          {props.title}
        </DialogTitle>
        <DialogContent>
          {props.prompt}
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={props.closeDialog} color="primary">
            No
          </Button>
          <Button
            onClick={() => {
              props.accept && props.accept();
            }}
            color="primary"
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
